import ajaxService from './ajaxService';

export default {
  // 檢查是否為 Line 官方帳號好友
  checkLineOfficeAccountFriend(body) {
    return ajaxService.post('/com/post/api/v1/check-friend', body);
  },
  // 取得 Line UserId
  getLineUserId(body) {
    return ajaxService.post('/com/post/api/v1/lineuserid', body);
  },
};
